import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import { useEffect } from 'react'

// Layouts
import AuthLayout from './layouts/AuthLayout'
import DashboardLayout from './layouts/DashboardLayout'

// Auth Pages
import LoginPage from './pages/auth/LoginPage'

// Dashboard Pages
import DashboardPage from './pages/dashboard/DashboardPage'
import RendezvousListPage from './pages/rendezvous/RendezvousListPage'
import RendezvousAddPage from './pages/rendezvous/RendezvousAddPage'
import RendezvousEditPage from './pages/rendezvous/RendezvousEditPage'
import RendezvousDetailPage from './pages/rendezvous/RendezvousDetailPage'
import AgendaPage from './pages/agenda/AgendaPage'
import UsersPage from './pages/users/UsersPage'
import ProfilsPage from './pages/profils/ProfilsPage'
import EquipesPage from './pages/equipes/EquipesPage'
import SettingsPage from './pages/settings/SettingsPage'

// Protected Route Component
const ProtectedRoute = ({ children, permission }) => {
  const { isAuthenticated, user, hasPermission } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

function App() {
  const { checkAuth, isLoading } = useAuthStore()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Chargement...</p>
      </div>
    )
  }

  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Dashboard Routes */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />

        {/* Rendezvous */}
        <Route
          path="/rendezvous"
          element={
            <ProtectedRoute permission="MODULE_LIST_RDV">
              <RendezvousListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rendezvous/add"
          element={
            <ProtectedRoute permission="ADD_RDV">
              <RendezvousAddPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rendezvous/:id/edit"
          element={
            <ProtectedRoute permission="MODIF_RDV">
              <RendezvousEditPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rendezvous/:id"
          element={
            <ProtectedRoute permission="VIEW_RDV">
              <RendezvousDetailPage />
            </ProtectedRoute>
          }
        />

        {/* Agenda */}
        <Route
          path="/agenda"
          element={
            <ProtectedRoute permission="MODULE_AGENDA">
              <AgendaPage />
            </ProtectedRoute>
          }
        />

        {/* Users */}
        <Route
          path="/users"
          element={
            <ProtectedRoute permission="MANAGE_USERS">
              <UsersPage />
            </ProtectedRoute>
          }
        />

        {/* Profiles */}
        <Route
          path="/profils"
          element={
            <ProtectedRoute permission="MANAGE_PROFILE">
              <ProfilsPage />
            </ProtectedRoute>
          }
        />

        {/* Teams */}
        <Route
          path="/equipes"
          element={
            <ProtectedRoute permission="MANAGE_EQUIPES">
              <EquipesPage />
            </ProtectedRoute>
          }
        />

        {/* Settings */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute permission="*">
              <SettingsPage />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
